{
  "familyId": "MET-GEW-OMREKEN",
  "questions": [
    {
      "id": "MET-GEW-OMREKEN-001",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een bakker heeft 2 kilogram meel nodig. Hoeveel gram is dat?",
      "options": ["2.000 g", "200 g", "20 g", "20.000 g"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "kg", "to": "g" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "kg", "to": "g", "value": 2, "highlight": true } }],
      "conceptId": "weight_kg_to_g",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.gew-trap-te-weinig", "optionIndex": 1, "label": "Vermenigvuldigt met 100 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-weinig", "optionIndex": 2, "label": "Vermenigvuldigt met 10 i.p.v. 1.000 (één stap)" },
          { "id": "met.gew-trap-te-veel", "optionIndex": 3, "label": "Vermenigvuldigt met 10.000 i.p.v. 1.000 (vier stappen)" }
        ]
      },
      "feedback": {
        "explanationText": "De bakker weet: van kilogram naar gram ga je op het metrieke trapje naar beneden: ×1.000. Waarom ×1.000? Omdat 'kilo' duizend betekent — 1 kilogram is letterlijk 1.000 gram. Dus: 2 kg = 2 × 1.000 = 2.000 g.",
        "solutionSteps": ["Van kg naar g = ×1.000 (kilo = duizend)", "2 × 1.000 = 2.000 g"],
        "distractorExplanations": {
          "0": "Goed! 2 kg × 1.000 = 2.000 g. Kilo betekent duizend!",
          "1": "Je dacht waarschijnlijk dat je met 100 vermenigvuldigt. Maar van kg naar g is ×1.000, niet ×100. Tip: 'kilo' betekent duizend. Onthoud: kg → g = ×1.000.",
          "2": "Je dacht waarschijnlijk dat je met 10 vermenigvuldigt. Maar van kg naar g is ×1.000. Op het metrieke trapje ga je drie stappen naar beneden: kg → hg → dag → g. Elke stap is ×10, dus totaal ×1.000.",
          "3": "Je dacht waarschijnlijk dat je met 10.000 vermenigvuldigt. Maar van kg naar g is ×1.000, niet ×10.000. Je gaat drie stappen, niet vier. Onthoud: kg → g = ×1.000."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-002",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een slager weegt 5.000 gram vlees af. Hoeveel kilogram is dat?",
      "options": ["50 kg", "0,5 kg", "5 kg", "500 kg"],
      "correctAnswer": 2,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "g", "to": "kg" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "g", "to": "kg", "value": 5000, "highlight": true } }],
      "conceptId": "weight_g_to_kg",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.gew-trap-te-weinig", "optionIndex": 0, "label": "Deelt door 100 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-veel", "optionIndex": 1, "label": "Deelt door 10.000 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-weinig", "optionIndex": 3, "label": "Deelt door 10 i.p.v. 1.000 (één stap)" }
        ]
      },
      "feedback": {
        "explanationText": "De slager weet: van gram naar kilogram ga je op het trapje omhoog: ÷1.000. Dus: 5.000 g = 5.000 ÷ 1.000 = 5 kg. Omhoog op het trapje = delen, omlaag = vermenigvuldigen.",
        "solutionSteps": ["Van g naar kg = ÷1.000", "5.000 ÷ 1.000 = 5 kg"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je door 100 deelt. Maar van g naar kg is ÷1.000. Je gaat drie stappen omhoog op het trapje. Onthoud: g → kg = ÷1.000.",
          "1": "Je dacht waarschijnlijk dat je door 10.000 deelt. Maar van g naar kg is ÷1.000. Denk aan het trapje: g → dag → hg → kg = drie stappen = ÷1.000.",
          "2": "Goed! 5.000 g ÷ 1.000 = 5 kg.",
          "3": "Je dacht waarschijnlijk dat je door 10 deelt. Maar dat is maar één stap op het trapje. Van g naar kg zijn het drie stappen: ÷10 × ÷10 × ÷10 = ÷1.000."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-003",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een apotheker weegt 1,5 kilogram kruiden af. Hoeveel gram is dat?",
      "options": ["150 g", "1.500 g", "15 g", "15.000 g"],
      "correctAnswer": 1,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "kg", "to": "g" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "kg", "to": "g", "value": 1.5, "highlight": true } }],
      "conceptId": "weight_kg_to_g_decimal",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.gew-trap-te-weinig", "optionIndex": 0, "label": "Vermenigvuldigt decimaal met 100 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-weinig", "optionIndex": 2, "label": "Vermenigvuldigt decimaal met 10 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-veel", "optionIndex": 3, "label": "Vermenigvuldigt decimaal met 10.000 i.p.v. 1.000" }
        ]
      },
      "feedback": {
        "explanationText": "De apotheker berekent: van kg naar g is ×1.000. Dus: 1,5 kg = 1,5 × 1.000 = 1.500 g. Handig: splits het op — 1 kg = 1.000 g, plus 0,5 kg = 500 g → totaal 1.500 g.",
        "solutionSteps": ["Van kg naar g = ×1.000", "1,5 × 1.000 = 1.500 g", "Check: 1.000 g + 500 g = 1.500 g ✓"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je met 100 vermenigvuldigt. Maar van kg naar g is ×1.000. Tip: splits het op — 1 kg = 1.000 g en 0,5 kg = 500 g. Samen: 1.500 g.",
          "1": "Goed! 1,5 × 1.000 = 1.500 g.",
          "2": "Je dacht waarschijnlijk dat je met 10 vermenigvuldigt. Maar van kg naar g is ×1.000. Op het trapje ga je drie stappen naar beneden, niet één.",
          "3": "Je dacht waarschijnlijk dat je met 10.000 vermenigvuldigt. Maar van kg naar g is ×1.000. Je gaat drie stappen op het trapje, niet vier."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-004",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een groenteboer heeft een zak aardappelen van 3 kg. Hoeveel gram is dat?",
      "options": ["30.000 g", "300 g", "30 g", "3.000 g"],
      "correctAnswer": 3,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "kg", "to": "g" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "kg", "to": "g", "value": 3, "highlight": true } }],
      "conceptId": "weight_kg_to_g_context",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.gew-trap-te-veel", "optionIndex": 0, "label": "Vermenigvuldigt met 10.000 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-weinig", "optionIndex": 1, "label": "Vermenigvuldigt met 100 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-weinig", "optionIndex": 2, "label": "Vermenigvuldigt met 10 i.p.v. 1.000" }
        ]
      },
      "feedback": {
        "explanationText": "De groenteboer weet: van kg naar g is ×1.000. Dus: 3 kg = 3 × 1.000 = 3.000 g. Zonder het metrieke trapje kun je ook zo denken: 1 kg = 1.000 g, dus 3 kg = 3 × 1.000 g = 3.000 g.",
        "solutionSteps": ["Van kg naar g = ×1.000", "3 × 1.000 = 3.000 g"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je met 10.000 vermenigvuldigt. Maar 'kilo' betekent duizend, dus kg → g = ×1.000. Vier stappen zou kg → mg zijn (milligram), niet kg → g.",
          "1": "Je dacht waarschijnlijk dat je met 100 vermenigvuldigt. Maar 'kilo' betekent duizend, dus kg → g = ×1.000, niet ×100. Vergelijk: 1 kg = 1.000 g, niet 100 g.",
          "2": "Je dacht waarschijnlijk dat je met 10 vermenigvuldigt. Maar dat is maar één stap op het trapje (kg → hg). Van kg naar g zijn het drie stappen: ×10 × ×10 × ×10 = ×1.000.",
          "3": "Goed! 3 kg = 3 × 1.000 = 3.000 g."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-005",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een postbode draagt een pakje van 750 gram. Hoeveel kilogram is dat?",
      "options": ["7,5 kg", "0,75 kg", "75 kg", "0,075 kg"],
      "correctAnswer": 1,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "g", "to": "kg" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "g", "to": "kg", "value": 750, "highlight": true } }],
      "conceptId": "weight_g_to_kg_decimal",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.gew-trap-te-weinig", "optionIndex": 0, "label": "Deelt door 100 i.p.v. 1.000 bij decimaal resultaat" },
          { "id": "met.gew-trap-te-weinig", "optionIndex": 2, "label": "Deelt door 10 i.p.v. 1.000" },
          { "id": "met.gew-trap-te-veel", "optionIndex": 3, "label": "Deelt door 10.000 i.p.v. 1.000" }
        ]
      },
      "feedback": {
        "explanationText": "De postbode berekent: van gram naar kilogram is ÷1.000. Dus: 750 g = 750 ÷ 1.000 = 0,75 kg. Handig: 1.000 g = 1 kg, dus 750 g = driekwart kg = 0,75 kg.",
        "solutionSteps": ["Van g naar kg = ÷1.000", "750 ÷ 1.000 = 0,75 kg", "Check: 0,75 kg = driekwart kg ✓"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je door 100 deelt: 750 ÷ 100 = 7,5. Maar van g naar kg is ÷1.000, niet ÷100. Onthoud: drie stappen omhoog op het trapje.",
          "1": "Goed! 750 g ÷ 1.000 = 0,75 kg.",
          "2": "Je dacht waarschijnlijk dat je door 10 deelt: 750 ÷ 10 = 75. Maar dat is maar één stap. Van g naar kg zijn het drie stappen: ÷1.000. 75 kg is ook onrealistisch voor een pakje!",
          "3": "Je dacht waarschijnlijk dat je door 10.000 deelt: 750 ÷ 10.000 = 0,075. Maar van g naar kg is ÷1.000, niet ÷10.000. Dat zou vier stappen zijn (g → mg richting)."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-006",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "fill_in",
      "question": "Reken om: 4 kg = ... gram. Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["4000", "4.000"],
        "caseSensitive": false,
        "placeholder": "... g"
      },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "kg", "to": "g" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "kg", "to": "g", "value": 4, "highlight": true } }],
      "conceptId": "weight_kg_to_g_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Van kg naar g = ×1.000. Dus 4 kg = 4 × 1.000 = 4.000 gram.",
        "solutionSteps": ["Van kg naar g = ×1.000", "4 × 1.000 = 4.000 g"]
      }
    },
    {
      "id": "MET-GEW-OMREKEN-007",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "fill_in",
      "question": "Reken om: 3.500 gram = ... kg. Typ het getal met een komma (bijv. 2,5).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["3,5", "3.5"],
        "caseSensitive": false,
        "placeholder": "... kg"
      },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "g", "to": "kg" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "g", "to": "kg", "value": 3500, "highlight": true } }],
      "conceptId": "weight_g_to_kg_fill_decimal",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Van g naar kg = ÷1.000. Dus 3.500 g = 3.500 ÷ 1.000 = 3,5 kg.",
        "solutionSteps": ["Van g naar kg = ÷1.000", "3.500 ÷ 1.000 = 3,5 kg"]
      }
    },
    {
      "id": "MET-GEW-OMREKEN-008",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "fill_in",
      "question": "Een recept vraagt 0,25 kg bloem. Hoeveel gram is dat? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["250"],
        "caseSensitive": false,
        "placeholder": "... g"
      },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "kg", "to": "g" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "weight", "from": "kg", "to": "g", "value": 0.25, "highlight": true } }],
      "conceptId": "weight_kg_to_g_fill_context",
      "variantIndex": 8,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Van kg naar g = ×1.000. Dus 0,25 kg = 0,25 × 1.000 = 250 gram. Handig: een kwart kilo = 250 gram.",
        "solutionSteps": ["Van kg naar g = ×1.000", "0,25 × 1.000 = 250 g", "Check: een kwart kilo = 250 g ✓"]
      }
    },
    {
      "id": "MET-GEW-OMREKEN-009",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "ordering",
      "question": "Zet deze gewichten op volgorde van licht naar zwaar.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["1.200 g", "2 kg", "500 g", "0,75 kg"],
        "correctOrder": [2, 3, 0, 1]
      },
      "conceptId": "weight_ordering_mixed_units",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "weight", "from": "kg", "to": "g" } }],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewichten vergelijken",
            "content": "Reken alles om naar dezelfde eenheid (gram). 500 g = 500 g. 0,75 kg = 750 g. 1.200 g = 1.200 g. 2 kg = 2.000 g. Volgorde: 500 g < 750 g < 1.200 g < 2.000 g.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om gewichten te vergelijken, reken je alles om naar dezelfde eenheid. In gram: 500 g = 500 g, 0,75 kg = 750 g, 1.200 g = 1.200 g, 2 kg = 2.000 g. Van licht naar zwaar: 500 g → 750 g → 1.200 g → 2.000 g.",
        "solutionSteps": [
          "Reken alles om naar gram",
          "500 g = 500 g, 0,75 kg = 750 g",
          "1.200 g = 1.200 g, 2 kg = 2.000 g",
          "Volgorde: 500 < 750 < 1.200 < 2.000"
        ]
      }
    },
    {
      "id": "MET-GEW-OMREKEN-010",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "categorize",
      "question": "Sorteer deze gewichten: welke zijn meer dan 1 kg en welke zijn minder dan 1 kg?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Minder dan 1 kg", "Meer dan 1 kg"],
        "items": [
          { "text": "800 g", "correctCategory": 0 },
          { "text": "1.500 g", "correctCategory": 1 },
          { "text": "0,5 kg", "correctCategory": 0 },
          { "text": "2.300 g", "correctCategory": 1 },
          { "text": "250 g", "correctCategory": 0 },
          { "text": "1,2 kg", "correctCategory": 1 }
        ]
      },
      "conceptId": "weight_categorize_threshold",
      "variantIndex": 10,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vergelijken met 1 kg",
            "content": "1 kg = 1.000 g. Reken alles om naar gram en vergelijk met 1.000. Minder dan 1.000 g = minder dan 1 kg. Meer dan 1.000 g = meer dan 1 kg.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Reken alles om naar gram en vergelijk met 1.000 g (= 1 kg). Minder dan 1 kg: 800 g, 0,5 kg (= 500 g), 250 g. Meer dan 1 kg: 1.500 g, 2.300 g, 1,2 kg (= 1.200 g).",
        "solutionSteps": [
          "1 kg = 1.000 g",
          "Minder dan 1 kg: 800 g, 500 g (0,5 kg), 250 g",
          "Meer dan 1 kg: 1.500 g, 2.300 g, 1.200 g (1,2 kg)"
        ]
      }
    }
  ]
}